import { render, staticRenderFns } from "./inquiry-price-goods.vue?vue&type=template&id=c7b3befa&scoped=true&"
import script from "./inquiry-price-goods.vue?vue&type=script&lang=js&"
export * from "./inquiry-price-goods.vue?vue&type=script&lang=js&"
import style0 from "./inquiry-price-goods.vue?vue&type=style&index=0&id=c7b3befa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7b3befa",
  null
  
)

export default component.exports